<template>
  <div class="achievement-wrapper bg-white shadow-sm p-4">
    <div class="achievement-action">
      <b-button @click="openAchievementModal()">Create Achievement</b-button>
    </div>

    <b-modal
      id="create-achievement-modal"
      :title="(form.id ? 'Edit' : 'Create') + ' Achievement'"
      class="text-light"
      content-class="border-0"
      dialog-class="dashboard-create-challenge-dialog border-0"
      header-class="text-dark"
      ok-title="Save"
      @ok="onSubmit"
    >
      <b-form @submit="onSubmit">
        <!-- Name -->
        <b-form-group
          id="name-group"
          class="textColor"
          description="(eg. Weekend Warrior, Perfect Month May)"
          label-for="name"
        >
          <template v-slot:label>
            Achievement Name:<sup class="text-danger font-16">*</sup>
          </template>
          <b-form-input
            id="name"
            v-model="form.name"
            :placeholder="`Enter Achievement Name`"
            required
            type="text"
          ></b-form-input>
        </b-form-group>
        <!-- Description -->
        <b-form-group
          id="description-group"
          class="textColor"
          description="(eg. For doing  workouts on weekends)"
          label-for="descripton"
        >
          <template v-slot:label>
            Achievement Description:<sup class="text-danger font-16">*</sup>
          </template>
          <b-form-input
            id="descripton"
            v-model="form.description"
            :placeholder="`Enter Achievement Description`"
            required
            type="text"
          ></b-form-input>
        </b-form-group>

        <!-- Config -->
        <b-form-group class="textColor">
          <!-- Start Date -->
          <template v-slot:label>
            Achievement Configuration:<sup class="text-danger font-16">*</sup>
          </template>
          <div
            class="d-flex mb-2 justify-content-between"
            style="column-gap: 15px;"
          >
            <p style="white-space: nowrap;">Start Date</p>
            <div class="w-80 d-flex" style="column-gap: 5px;">
              <b-form-datepicker
                placeholder="Add Date"
                v-model="form.start_date"
              ></b-form-datepicker>
              <b-button
                variant="outline-secondary"
                @click="form.start_date = null"
                >Clear</b-button
              >
            </div>
          </div>
          <!-- End Date -->
          <div
            class="d-flex mb-2 justify-content-between"
            style="column-gap: 15px;"
          >
            <p style="white-space: nowrap;">End Date</p>
            <div class="w-80 d-flex" style="column-gap: 5px;">
              <b-form-datepicker
                placeholder="Add Date"
                v-model="form.end_date"
              ></b-form-datepicker>
              <b-button
                variant="outline-secondary"
                @click="form.end_date = null"
                >Clear</b-button
              >
            </div>
          </div>
          <!-- Points -->
          <div
            class="d-flex mb-2 justify-content-between"
            style="column-gap: 15px;"
          >
            <p style="white-space: nowrap;">Points</p>
            <div class="w-80 d-flex" style="column-gap: 5px;">
              <b-form-input
                id="points"
                v-model="form.points"
                :placeholder="`Enter Achievement Points`"
                required
                type="number"
                min="0"
              ></b-form-input>
            </div>
          </div>
          <!-- Week Day selection -->
          <div
            class="d-flex mb-2 justify-content-between"
            style="column-gap: 15px;"
          >
            <p style="white-space: nowrap;">Week Day</p>
            <div class="w-80">
              <div class="week-days">
                <div
                  v-for="(day, i) of ['M', 'T', 'W', 'T', 'F', 'S', 'S']"
                  class="week-day"
                  :style="{
                    backgroundColor:
                      form.day_of_week && form.day_of_week.includes((i + 1) % 7)
                        ? '#8DC63F'
                        : '#ffffff',
                  }"
                  @click="toogleDayofWeek((i + 1) % 7)"
                >
                  <span class="text-center">{{ day }}</span>
                </div>
              </div>
              <div style="margin-left: 1.6px;">
                <b>Note:</b> If you select a specific day, we’ll only consider
                workouts completed on that weekday for your achievement.
                Otherwise, we’ll include workouts from all weekdays.
              </div>
            </div>
          </div>
          <!-- Scope Selection -->
          <div
            class="d-flex mb-2 justify-content-between"
            style="column-gap: 15px;"
          >
            <p style="white-space: nowrap;">
              Evaluation Method :<sup class="text-danger font-16">*</sup>
            </p>
            <div class="d-flex flex-column w-80">
              <b-form-select
                class="w-100"
                v-model="form.config.scope"
                :options="scopeOptions"
              ></b-form-select>
              <div style="margin-left: 1.6px;">
                <b>All Workouts</b>: Metrics from all workouts will be included
                in the calculation for this badge. <br />
                <b>Per Workout</b>: Metrics will be tracked for each workout
                performed after this badge is created.
              </div>
            </div>
          </div>

          <div v-for="(_, index) in form.config.config" :key="index">
            <div class="d-flex align-items-start" style="column-gap: 10px;">
              <div class="w-20">
                <div v-if="index == 0">
                  Condition<sup class="text-danger font-16">*</sup>
                </div>
                <div v-else-if="index == 1">
                  <b-form-select
                    :options="conditionOptions"
                    v-model="form.config.operator"
                    @change="changeOperator"
                  ></b-form-select>
                </div>
                <div v-else>{{ form.config.operator }}</div>
              </div>
              <div class="w-80 config-background mb-2 p-2 rounded">
                <div
                  v-for="(_, i) in form.config.config[index].config"
                  :key="i"
                >
                  <div
                    class="d-flex align-items-center"
                    style="column-gap: 10px;"
                  >
                    <div class="w-20 mb-2">
                      <div v-if="i == 0">Where</div>
                      <b-form-select
                        :options="conditionOptions"
                        v-model="form.config.config[index].operator"
                        v-else-if="i == 1"
                      ></b-form-select>
                      <div v-else>
                        {{ form.config.config[index].operator }}
                      </div>
                    </div>
                    <div
                      class="d-flex mb-2 align-items-center flex-row w-80"
                      style="column-gap: 10px;"
                    >
                      <b-form-select
                        style="width: 30%;"
                        :options="columnOptions"
                        v-model="form.config.config[index].config[i].type"
                      >
                      </b-form-select>
                      <b-form-select
                        style="width: 30%;"
                        :options="operatorOptions"
                        v-model="form.config.config[index].config[i].operator"
                      ></b-form-select>
                      <b-form-input
                        v-model="form.config.config[index].config[i].value"
                        placeholder="Value"
                        required
                        type="number"
                        style="width: 30%;"
                        min="0"
                      ></b-form-input>
                      <b-icon
                        icon="trash-fill"
                        aria-hidden="true"
                        @click="
                          form.config.config[index].config.splice(i, 1);
                          if (form.config.config[index].config.length == 0) {
                            form.config.config.splice(index, 1);
                          }
                        "
                      ></b-icon>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-flex justify-content-end mb-1">
                  <b-button
                    variant="outline-secondary"
                    @click="
                      form.config.config[index].config.push({
                        type: 'time',
                        operator: 'gt',
                        value: '',
                      })
                    "
                    >Add new Config</b-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="w-100 d-flex justify-content-start">
            <b-button
              variant="outline-secondary"
              @click="
                form.config.config.push({
                  config: [
                    {
                      type: 'time',
                      operator: 'gt',
                      value: '',
                    },
                  ],
                  operator: 'and',
                  type: 'condition',
                });
                if (!form.config.operator) {
                  form.config.operator = 'and';
                }
              "
              >Add new Group</b-button
            >
          </div>
        </b-form-group>

        <!-- Image -->
        <b-form-group class="textColor">
          <template v-slot:label>
            Achievement Thumbnail:<sup class="text-danger font-16">*</sup>
          </template>
          <b-row style="align-items: center">
            <b-col cols="8">
              <b-form-input
                v-model="thumbnailTitle"
                disabled
                maxlength="50"
                placeholder="Upload thumbnail"
                required
                size="sm"
                trim
              ></b-form-input>
            </b-col>
            <b-col cols="4">
              <b-button
                ref="thumbnailTitle"
                class="pill-button"
                @click="
                  $refs.thumbnail.$el.querySelector('input[type=file]').click()
                "
                >SELECT</b-button
              >
            </b-col>
          </b-row>
          <b-form-file
            ref="thumbnail"
            v-model="thumbnail"
            :state="Boolean(thumbnail)"
            accept="image/*"
            class="d-none"
            placeholder="Select Files"
            required
            size="sm"
            @input="handleImageChange($event)"
          ></b-form-file>

          <b-row class="preview-media-row">
            <div class="preview-media-wrapper">
              <ul>
                <li
                  v-for="(thumb, index) in thumbnailOptions"
                  :key="index"
                  class="preview-media"
                >
                  <img
                    :src="thumb.url"
                    alt="preview"
                    draggable="false"
                    :class="{
                      'cursor-pointer': thumbnailActiveIndex !== index,
                      'thumbnail-selected': thumbnailActiveIndex === index,
                    }"
                    @click="addSelectedMedia(index)"
                  />
                  <div
                    class="remove-media"
                    v-if="thumbnailActiveIndex === index"
                  >
                    <b-icon
                      class="remove-media-icon"
                      icon="x"
                      @click="removeMedia(index)"
                    ></b-icon>
                  </div>
                </li>
              </ul>
            </div>
          </b-row>
        </b-form-group>

        <!-- Active and One time -->
        <div>
          <div class="mb-2">
            <b-form-checkbox
              id="is_one_time"
              v-model="form.is_one_time"
              name="is_one_time"
              :value="true"
              :unchecked-value="false"
            >
              One time
            </b-form-checkbox>
            <div class="font-14 text-secondary" v-if="form.is_one_time">
              This achievement will only be awarded one time
            </div>
          </div>
          <b-form-checkbox
            id="is_active"
            v-model="form.is_active"
            name="is_active"
            :value="true"
            :unchecked-value="false"
          >
            Active
          </b-form-checkbox>

          <div class="font-14 text-secondary" v-if="!form.is_active">
            This achievement is inactive and will not be tracked for future
            workouts.
          </div>
        </div>
      </b-form>
    </b-modal>

    <div v-if="isFetchingAchievementList" class="w-100 my-2 text-center">
      <b-spinner />
    </div>

    <div v-if="!isFetchingAchievementList && achievementList.length != 0">
      <b-table
        :fields="tableFields"
        class="mt-2"
        :items="achievementList"
        responsive
      >
        <template #cell(actionButtons)="data">
          <b-col
            class="d-flex flex-column p-0"
            v-if="data.item.tenant_id != null"
          >
            <b-button
              class="mr-1 mb-1 table-col-button"
              size="sm"
              @click="openAchievementModal(data.item)"
            >
              Edit
            </b-button>
            <b-button
              class="mr-1 table-col-button"
              variant="danger"
              size="sm"
              @click="deleteAchievement(data.item)"
            >
              Delete
            </b-button>
          </b-col>
        </template>
        <template #cell(is_active)="data">
          <div class="slider-container">
            <div class="switch" @click="toggleActiveAchievement(data.item)">
              <div :class="{ on: data.item.is_active }" class="slider"></div>
            </div>
          </div>
        </template>
        <template #cell(is_one_time)="data">
          <div class="position-relative">
            <b-icon
              :style="{
                color: data.item.is_one_time ? '#73bc44' : 'grey',
                top: '-30px',
                left: '-15px',
              }"
              class="position-absolute"
              font-scale="5"
              icon="dot"
            ></b-icon>
          </div>
        </template>
        <template #cell(image)="data">
          <div class="row">
            <img
              :src="data.item.image"
              v-if="data.item.image"
              style="max-width: 180px;"
            />
          </div>
        </template>
        <template #cell(name)="data">
          {{ data.item.name }}
          <br />
          <b-badge variant="secondary" v-if="!data.item.tenant_id"
            >From EliteFit.AI</b-badge
          >
        </template>
      </b-table>
      <div class="d-flex w-100 justify-content-center pagination-action">
        <b-pagination
          v-model="page"
          :per-page="pageSize"
          :total-rows="totalRecords"
          align="fill"
          class="my-0"
          size="sm"
        ></b-pagination>
      </div>
    </div>

    <div
      v-if="zeroContentAdded"
      class="w-100 d-flex align-items-center justify-content-center"
    >
      <div
        class="d-flex flex-column flex-md-row"
        style="column-gap: 10px; row-gap: 10px;"
      >
        <img
          src="../../../module_b2b_users/assets/images/achievements.png"
          style="height: 300px; width: 300px;"
        />
        <div
          class="d-flex flex-column align-items-start justify-content-center pb-4"
          style="row-gap: 10px;"
        >
          <div class="font-weight-700 font-20">
            No Achievement Found
          </div>
          <div class="font-weight-400 font-14">
            Create achievements to motivate your users.
          </div>
          <div class="achievement-action">
            <b-button @click="openAchievementModal()"
              >Create Achievement</b-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import achievementApi from "../../api/achievement";
import S3Url from "@/module_admin/s3upload/getSignedURL";
import moment from "moment";

const { mapActions } = createNamespacedHelpers("admin/trainerVideosView");
export default {
  name: "AchievementManagement",
  data() {
    return {
      tableFields: [
        {
          key: "image",
          label: "Image",
        },
        {
          key: "name",
          label: "Name",
        },
        {
          key: "description",
          label: "Description",
        },
        {
          key: "is_active",
          label: "Active",
        },
        {
          key: "is_one_time",
          label: "One time",
        },
        {
          key: "actionButtons",
          label: "Action Buttons",
        },
      ],
      achievementList: [],
      form: {
        id: null,
        name: "",
        description: "",
        image: "",
        isOneTime: "",
        points : "",
        config: { scope: "current", config: [] },
      },
      scopeOptions: [
        { value: "overall", text: "All Workouts" },
        { value: "current", text: "Per Workout" },
      ],
      conditionOptions: ["and", "or"],
      columnOptions: [
        { value: null, text: "Properties", disabled: true },
        { value: "time", text: "Duration(in s)" },
        { value: "score", text: "Score", max: 100 },
        { value: "calories_burnt", text: "Calories" },
        { value: "complete_percentage", text: "Complete Percentage", max: 100 },
      ],
      operatorOptions: [
        { value: null, text: "Operator", disabled: true },
        { value: "gt", text: "Greater than" },
        { value: "gte", text: "Greater than equal to" },
        { value: "eq", text: "Equal to " },
        { value: "lt", text: "Less than" },
        { value: "lte", text: "Less than equal to" },
      ],
      thumbnailTitle: "",
      thumbnail: null,
      thumbnailFile: "",
      thumbnailOptions: [],
      selectedThumbnail: null,
      thumbnailActiveIndex: 0,

      page: 1,
      pageSize: 15,
      totalRecords: 1,
      isFetchingAchievementList: true,
      zeroContentAdded: false,
    };
  },
  methods: {
    ...mapActions(["getS3Cred"]),
    openAchievementModal(data) {
      this.resetForm();
      if (data) {
        this.form = { start_date: "", end_date: "", day_of_week: [], ...data };
        this.thumbnailTitle = data.image;
        if (!this.form.config) {
          this.form.config = {
            scope: "current",
            config: [],
            operator: "and",
            type: "condition",
          };
        }
      }
      this.$root.$emit("bv::show::modal", "create-achievement-modal");
    },
    closeAchievementModal() {
      this.$root.$emit("bv::hide::modal", "create-achievement-modal");
    },
    resetForm() {
      this.form = {
        id: null,
        name: "",
        description: "",
        image: "",
        isOneTime: "",
        points : "",
        config: {
          scope: "current",
          operator: "and",
          type: "operator",
          config: [
            {
              config: [
                {
                  operator: "gt",
                  type: "time",
                  value: "",
                },
              ],
              operator: "and",
              type: "condition",
            },
          ],
        },
        start_date: "",
        end_date: "",
        day_of_week: [],
        is_active: true,
      };
    },
    toggleActiveAchievement({ id, name, tenant_id, is_active }) {
      let message = `"${name}" will be `;
      if (is_active) {
        message += "disabled";
      } else {
        message += "enabled";
      }

      this.$swal
        .fire({
          title: message,
          showDenyButton: true,
          confirmButtonText: "Yes",
          denyButtonText: `No`,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              if (tenant_id) {
                await achievementApi.updateAchievement(id, {
                  is_active: !is_active,
                });
              }
              if (!tenant_id) {
                await achievementApi.deleteAchievement(id);
              }

              this.makeToast(
                "success",
                "",
                `Achievement ${is_active ? "Disabled" : "Enabled"}`
              );
              this.fetchAchievementList();
            } catch (e) {
              this.makeToast("danger", "", "Failed to update");
            }
          }
        });
    },
    deleteAchievement({ id, name }) {
      const title = ` Are you sure to delete "${name}"?`;
      const text = `"${name}" will be deleted and those who have earned this achievement will no longer be able see it`;
      this.$swal
        .fire({
          title,
          text,
          showDenyButton: true,
          confirmButtonText: "Yes",
          denyButtonText: `No`,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              await achievementApi.deleteAchievement(id);
              this.makeToast("success", "", "Achievement badge deleted");
              this.fetchAchievementList();
            } catch (e) {
              this.makeToast("danger", "", "Failed to delete");
            }
          }
        });
    },
    handleImageChange(e) {
      this.thumbnailTitle = e.name;
      this.thumbnailFile = e;
      const reader = new FileReader();

      reader.onload = (event) => {
        const arrayBuffer = event.target.result;
        this.thumbnail = new File([arrayBuffer], e.name, { type: e.type });
        this.onUpload({
          name: this.thumbnailTitle,
          thumbnailFile: this.thumbnail,
        });
      };
      reader.readAsArrayBuffer(e);
    },
    onUpload({ name, thumbnailFile }) {
      const thumbnail = URL.createObjectURL(thumbnailFile);
      const index = this.thumbnailOptions.findIndex(
        (thum) => thum.url === thumbnail
      );
      if (index > -1) this.addSelectedMedia(index);
      else {
        this.thumbnailOptions.push({
          url: thumbnail,
          name,
          needUpload: true,
        });
        this.addSelectedMedia();
      }
    },
    addSelectedMedia(index) {
      index = index ?? Math.max(this.thumbnailOptions.length - 1, 0);
      this.selectedThumbnail = this.thumbnailOptions[index];
      this.updateThumbnailInfo();
    },
    removeMedia(index) {
      if (this.selectedThumbnail.url == this.thumbnailOptions[index].url) {
        this.selectedThumbnail = this.thumbnailOptions[
          (index - 1) % (this.thumbnailOptions.length - 1)
        ];
      }
      this.thumbnailOptions.splice(index, 1);
      this.updateThumbnailInfo();
    },
    updateThumbnailInfo() {
      this.form.image = this.selectedThumbnail.url;
      this.thumbnailTitle =
        this.selectedThumbnail.name ?? this.form.image?.split("/").pop();
    },
    makeToast(variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
    toogleDayofWeek(i) {
      const index = this.form.day_of_week.indexOf(i);

      if (index > -1) {
        this.form.day_of_week.splice(index, 1);
      } else {
        this.form.day_of_week.push(i);
      }
      this.form.day_of_week.sort();
    },
    async onSubmit(e) {
      e && e.preventDefault();

      if (!this.form.name || this.form.name.trim() == "") {
        this.makeToast("danger", "Field is Required", "Name cannot be blank");
        return;
      }

      if (!this.form.description || this.form.description.trim() == "") {
        this.makeToast(
          "danger",
          "Field is Required",
          "Description cannot be blank"
        );
        return;
      }

      if (!this.thumbnailTitle) {
        this.makeToast(
          "danger",
          "Field is Required",
          "Achievement thumbnail cannot be blank"
        );
        return;
      }

      const isValidated = this.valdidateForm();
      if (!isValidated) {
        return;
      }
      const formData = this.form;

      const needUpload =
        this.selectedThumbnail && this.selectedThumbnail.needUpload;
      if (needUpload) {
        await this.getS3Cred();
        let s3Cred = this.$store.state.admin.trainerVideosView.s3Cred;
        //upload thumbnail to s3
        let thumbResponse = await S3Url.getS3Url(
          s3Cred,
          this.thumbnailFile,
          this.thumbnail,
          "thumbnails"
        );
        formData.image = thumbResponse.Location;
      }
      try {
        if (formData.id) {
          await achievementApi.updateAchievement(formData.id, formData);
        } else {
          delete formData.id;
          await achievementApi.createAchievement(formData);
        }
        this.makeToast(
          "success",
          `Achievement ${formData.id ? "Updated" : "Created"}`,
          `Achievement ${formData.id ? "Updated" : "Created"} Successfully`
        );
        await this.fetchAchievementList();
        this.closeAchievementModal();
      } catch (error) {
        this.makeToast("danger", `Error`, `Failed to create achievement`);
      }
    },
    validateConfig(config) {
      if (config.operator == "and" || config.operator == "or") {
        for (const c of config.config) {
          if (!this.validateConfig(c)) {
            return false;
          }
        }
        return true;
      } else {
        if (!config.operator || config.operator == "") {
          this.makeToast(
            "danger",
            "Incomplete Form",
            "Please fill all operators in conditions"
          );
          return false;
        }

        if (!config.type || config.type == "") {
          this.makeToast(
            "danger",
            "Incomplete Form",
            "Please fill all Properties in conditions"
          );
          return false;
        }

        if (!config.value || config.value == "") {
          this.makeToast(
            "danger",
            "Incomplete Form",
            "Please fill all Values in conditions"
          );
          return false;
        }

        if (parseInt(config.value) < 0) {
          this.makeToast(
            "danger",
            "Incomplete Form",
            "Value should be a positive number"
          );
          return false;
        }

        const option = this.columnOptions.find(({ value }) => {
          return value == config.type;
        });

        // Integer Error
        if (
          ["number_of_workouts", "number_of_videos"].includes(config.type) &&
          !Number.isInteger(parseInt(config.value))
        ) {
          this.makeToast(
            "danger",
            "Invalid Valid",
            `${option.text} should be an integer`
          );
          return false;
        }

        if (config.operator == "gt") {
          if (
            ["score", "complete_percentage"].includes(config.type) &&
            config.value >= 100
          ) {
            this.makeToast(
              "danger",
              "Invalid Value",
              `${option.text}  cannot be greater than 100`
            );
            return false;
          }
        }

        if (config.operator != "gt") {
          const value =
            config.operator == "lt" ? config.value <= 1 : config.value < 1;
          if (
            [
              "number_of_workouts",
              "number_of_videos",
              "time",
              "score",
              "complete_percentage",
            ].includes(config.type) &&
            value
          ) {
            this.makeToast(
              "danger",
              "Invalid Valid",
              `${option.text} cannot be less than 1`
            );
            return false;
          }

          if (config.type == "calories_burnt" && config.value == 0) {
            this.makeToast(
              "danger",
              "Invalid Valid",
              `${option.text} should be greater than 0`
            );
            return false;
          }
        }

        return true;
      }
    },
    valdidateForm() {
      if (this.form.start_date && this.form.end_date) {
        if (moment(this.form.start_date).isAfter(moment(this.form.end_date))) {
          this.makeToast(
            "danger",
            "Invalid Date",
            "Start Date is greater than end date"
          );
          return false;
        }
      }
      
      if(this.form.points < 0){
         this.makeToast(
            "danger",
            "Invalid Points",
            "Points should be positive"
          );
        return false
      }

      return this.validateConfig(this.form.config);
    },

    async fetchAchievementList() {
      try {
        this.isFetchingAchievementList = true;
        this.zeroContentAdded = false;
        const response = await achievementApi.getAchievementList({
          page: this.page,
          pageSize: this.pageSize,
        });
        this.totalRecords = response.data.totalRecords;
        this.achievementList = response.data.achievement;
        this.zeroContentAdded = response.data.achievement.length == 0;
      } catch (error) {
        this.makeToast("danger", `Error`, `Failed to fetch achievements`);
      } finally {
        this.isFetchingAchievementList = false;
      }
    },
    changeOperator() {
      this.$forceUpdate();
    },
  },
  async mounted() {
    await this.fetchAchievementList();
  },
  watch: {
    async page() {
      await this.fetchAchievementList();
    },
    "form.config.scope"(newScope) {
      if (newScope == "overall") {
        this.columnOptions = [
          { value: null, text: "Properties", disabled: true },
          { value: "time", text: "Duration(in s)" },
          { value: "score", text: "Score", max: 100 },
          { value: "calories_burnt", text: "Calories" },
          {
            value: "complete_percentage",
            text: "Complete Percentage",
            max: 100,
          },
          { value: "number_of_workouts", text: "Total Workouts" },
          { value: "number_of_videos", text: "Unique Workouts" },
        ];
      } else if (newScope == "current") {
        this.columnOptions = [
          { value: null, text: "Properties", disabled: true },
          { value: "time", text: "Duration(in s)", max: 100 },
          { value: "score", text: "Score" },
          { value: "calories_burnt", text: "Calories" },
          { value: "complete_percentage", text: "Complete Percentage" },
        ];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.achievement-wrapper {
  border-radius: 10px;

  .achievement-action {
    .btn {
      display: inline-flex;
      align-items: center;
      justify-content: space-between;

      text-decoration: none !important;
      border: none;
      box-shadow: 0px 16px 49px rgb(20 21 19 / 15%);
      border-radius: 18px;
      box-shadow: none;
      background-color: #73bc44;
      padding: 6px 12px;
      text-align: center;
      white-space: nowrap;
      height: 32px;
      font-size: 12px;
      line-height: 18px;
      font-weight: 700 !important;
    }
  }
}

.week-days {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .week-day {
    width: 40px;
    height: 40px;
    border: 1px solid black;
    border-radius: 50%;
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}

.config-background {
  background-color: #8080801c;
}

.preview-media-row {
  margin: 0 0 auto;
  padding: 8px 0px;

  .preview-media-wrapper {
    max-width: 100%;

    ul {
      margin-bottom: 0;
      overflow-x: scroll;
      white-space: nowrap;

      li {
        display: inline-block;
        list-style-type: none;
        text-decoration: none;
        margin-right: 8px;
        width: 64px;
        height: 64px;
        overflow: hidden;
        border-radius: 8px;
        position: relative;
        transition: transform 0.5s ease;
      }

      .thumbnail-selected {
        border: 2px green solid;
        border-radius: 8px;
      }
    }

    .preview-media {
      video,
      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
        max-height: 100%;
        max-width: 100%;
      }

      .remove-media {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: all;

        .remove-media-icon {
          cursor: pointer;
          position: absolute;
          top: 0;
          right: 0;
          z-index: 1;
          width: 16px;
          height: 16px;
          background-color: #fff;
          color: black;
          border-radius: 50%;
        }
      }
    }
  }
}

.slider-container {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0;
  text-align: center;

  .switch {
    display: inline-block;
    width: 40px;
    height: 20px;
    position: relative;
    cursor: pointer;
  }

  .switch .slider {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    border-radius: 34px;
    transition: 0.4s;
  }

  .switch .slider.on {
    background-color: #73bd45;
  }

  .switch .slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    border-radius: 50%;
    transition: 0.4s;
  }

  .switch .slider.on:before {
    transform: translateX(20px);
  }
}

.pagination-action {
  margin: 16px auto;

  ::v-deep pagination {
    display: flex;
  }

  ::v-deep li {
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    margin-right: 16px;
    border: 1px solid black;
    border-radius: 5px;
    background-color: #ffffff;
    flex-grow: 0 !important;

    &:last-child {
      margin-right: 0;
    }

    &.active {
      background-color: #73bd45;

      .page-link {
        color: #ffffff;
      }
    }
  }

  ::v-deep .page-link {
    border: none;
    box-shadow: none;
    background: transparent;
    color: black;
    margin: 0;
    padding: 0.25rem 0.8rem;
  }
}

::v-deep .custom-control-label::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e") !important;
}
</style>
